// @flow
import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';

import type {Node} from 'react';

type Props = {
    children?: Node,
    pixelOffset: Object, // google maps size object
    infoBoxClearance?: Object, // also google maps size object
    marker?: Object, // google maps marker object
    map?: Object // google maps map object
};

export default class Overlay extends PureComponent<Props> {
    infobox: Object;
    content: Object;

    constructor(props: Props) {
        super();

        const {pixelOffset, map, infoBoxClearance} = props;
        const {InfoBox} = require('google-maps-infobox');
        const infobox = new InfoBox({
            closeBoxURL: '', // hide the X (close) button
            pixelOffset,
            infoBoxClearance,
            alignBottom: true,
            boxStyle: {
                overflow: 'visible'
            }
        });
        infobox.setMap(map);
        this.infobox = infobox;
        this.content = document.createElement('div');
    }

    componentDidMount() {
        this.infobox.setContent(this.content);
        this.infobox.open(this.props.map, this.props.marker);
    }

    componentWillUnmount() {
        if (this.infobox && this.infobox.getContent()) {
            this.infobox.setMap(null);
        }
    }

    render() {
        return ReactDOM.createPortal(
            React.Children.only(this.props.children),
            this.content
        );
    }
}
